import { trackPage } from "./src/utils/analytics"

export const onRouteUpdate = ({ location }) => {
    trackPage({
        path: location.pathname
    })
}